// Per-user library of saved quote items (LibraryTemplate).
//
// Fetches the current user's templates from /library-templates/, optionally
// filtered by product_type (e.g. 'windows' / 'patiodoors'). Refreshes on the
// 'library-templates-updated' window event (dispatched after a save / picker
// instantiate) and on the 'logout' event.
//
// Used by additem.js (to decide whether to show "Add from the library…" and
// to fill the picker) and the future delete/rename UI (Phase 2).

import { useEffect, useState, useCallback } from 'react';
import { authFetch } from './api';
import { getCookie } from './cookies';

export const useLibraryTemplates = (productType) => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!getCookie('access_token')) {
      setItems([]); setLoaded(true);
      return;
    }
    try {
      const qs = productType ? `?product_type=${encodeURIComponent(productType)}` : '';
      const data = await authFetch(`/library-templates/${qs}`);
      setItems(Array.isArray(data) ? data : []);
    } catch {
      // silent — don't disturb user
    } finally {
      setLoaded(true);
    }
  }, [productType]);

  useEffect(() => {
    refresh();
    const onUpdate = () => refresh();
    const onLogout = () => setItems([]);
    window.addEventListener('library-templates-updated', onUpdate);
    window.addEventListener('logout', onLogout);
    return () => {
      window.removeEventListener('library-templates-updated', onUpdate);
      window.removeEventListener('logout', onLogout);
    };
  }, [refresh]);

  return { items, count: items.length, loaded, refresh };
};
